<template>
  <div class="focus-area">

    <header-bar process="signup"></header-bar>

    <section class="instructions">
      <div class="grid-container">
        <div class="col-4">
          <h2>Choose up to <span class="bold">five</span> focus areas you currently work or have expertise in.</h2>
        </div>
      </div>
    </section>
    <section class="item-selection">
      <div class="grid-container">

        <div class="row" v-for="row in chunkArray">
          <picker-item v-for="item, key in row" itemclass="focus-areas" :itemid="item['.key']" :itemname="item.name" :itemimg="item.img" :key="key">
        </picker-item>
        </div>

      </div>
    </section>

    <section class="sign-up-navigation">
      <div class="grid-container">
        <a href="#" v-on:click.stop.prevent="stepBack" class="link-back">Learn about reputation</a>
        <a href="#" v-on:click.stop.prevent="progress" class="btn btn-big bg-four active">Next</a>

        <div class="item-added-holder">

          <slider :data="selectedItemTags" :items="noOfItems"></slider>

        <!-- <a v-if="overflow" class="left-arrow"></a>

          <div class="item-added-container">

            <div class="item-added-items overflow" :class="{ overflow: overflow }">
              
              <div class="btn-item-added" id="checkOverflow" v-for="tag in selectedItemTags">{{ tag.name }}<a class="remove" @click.stop.prevent="removeTag(tag.id, tag.name)"></a></div>
              

            </div>

          </div>

         <a v-if="overflow" class="right-arrow"></a>
 -->
        </div>

      </div>
    </section>


  </div>
</template>

<script>
import { db } from '@/firebase'
// import jQuery from 'jquery'

import HeaderBar from '@/components/HeaderBar'
import PickerItem from '@/components/register/PickerItem'
import Slider from '@/components/register/Slider'

export default {
  data () {
    return {
      selectedItems: [],
      selectedItemTags: []
    }
  },
  components: {
    HeaderBar,
    PickerItem,
    Slider
  },
  methods: {
    stepBack () {
      this.$parent.currentStep--
    },
    progress () {
      let focusData = {}
      let user = this.$root.user.uid

      for (var i = 0; i < this.selectedItems.length; ++i) {
        focusData[this.selectedItems[i]] = true
        // let userData = {[user]: true}
        // db.ref('attributes/focus-areas/' + this.selectedItems[i] + '/users').update(userData)
      }
      let parent = this
      db.ref('users-registration/' + user + '/personality/focus-areas').set(focusData, function () {
        // On complete
        console.log('saved')
        parent.$parent.currentStep++
      })
    }
  },
  firebase: function () {
    return {
      focusAreas: {
        source: db.ref('attributes/focus-areas/')
      }
    }
  },
  computed: {
    chunkArray: function () {
      let chunks = []
      let arr = this.focusAreas
      let i
      let chunkSize = 4

      for (i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize))
      }
      return chunks
    },
    noOfItems: function () {
      return this.selectedItems.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register-Step-5.vue?b6ea1684